import React, { useEffect, useState } from 'react'
import Table from 'react-bootstrap/Table'
import Button from 'react-bootstrap/Button'

import config from '../../config'
import locationApi from '../../utils/locationApi'

import EditBranchModal from '../Modal/EditBranchModal'
import AddBranchModal from '../Modal/AddBranchModal'

const url = config.api.baseUrl + '/branches'

const Branches = (props) => {
  const [branches, setBranches] = useState([])
  const [showAddBranchModal, setShowAddBranchModal] = useState(false)
  const [editBranchModalData, setEditBranchModalData] = useState()

  const toggleAddBranchModal = () => setShowAddBranchModal(!showAddBranchModal)
  const toggleEditBranchModal = (data) => setEditBranchModalData(data)

  useEffect(() => {
    (async () => {
      const res = await locationApi('get', url)
      setBranches(res.data)
    })()
  }, [showAddBranchModal, editBranchModalData])

  return (
    <>
      {editBranchModalData ? <EditBranchModal data={editBranchModalData} onClose={toggleEditBranchModal} /> : null}
      <Table hover>
        <thead>
          <tr>
            <th>ID</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          {
            branches.map((item) => {
              return (
                <tr key={item._id}>
                  <td style={{ cursor: 'pointer' }} onClick={() => toggleEditBranchModal(item)}>{item.name}</td>
                  <td>{item.description}</td>
                </tr>
              )
            })
          }
        </tbody>
      </Table>
      <Button variant='primary' onClick={toggleAddBranchModal}>Add Branch</Button>
      <AddBranchModal show={showAddBranchModal} onClose={toggleAddBranchModal} />
    </>
  )
}

export default Branches
